<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h2>Edit event</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveEvent">
          <div class="mb-3">
            <!-- Event Code -->
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="eventData.code" ref="codeInput" required>
            <div v-if="eventCodeError" class="text-danger">{{ eventCodeError }}</div>
          </div>
          <div class="mb-3">
            <!-- Event Name -->
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="eventData.name" required>
            <div v-if="eventNameError" class="text-danger">{{ eventNameError }}</div>
          </div>
          <div class="mb-3">
            <!-- Event Date -->
            <label for="date" class="form-label">Date</label>
            <input type="date" class="form-control" id="date" v-model="eventData.date" required>
          </div>
          <fieldset class="border p-2">
            <legend class="w-auto px-2">Shift timing</legend>
            <div class="mb-3">
              <label for="default_shift_start_time" class="form-label">Default start time</label>
              <input type="time" class="form-control" id="default_shift_start_time"
                     v-model="eventData.default_shift_start_time" required>
            </div>
            <div class="mb-3">
              <label for="default_shift_duration" class="form-label">Default duration</label>
              <input type="time" class="form-control" id="default_shift_duration"
                     v-model="eventData.default_shift_duration" required>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveEvent"
                :disabled="isSaveButtonDisabled">Save changes
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import {checkEventCodeUnique, checkEventNameUnique} from '@/utils/mycrew_functions';

export default {
  name: 'EditEventModal',
  props: {
    event: {
      type: Object,
      required: true,
    },
    organisation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      eventData: {},
      initialEventCode: '',
      initialEventName: '',
      eventCodeError: '',
      eventNameError: '',
    };
  },
  computed: {
    isSaveButtonDisabled() {
      return !this.eventData.code ||
          !this.eventData.name ||
          !this.eventData.date ||
          this.eventCodeError !== '' ||
          this.eventNameError !== '';
    },
  },
  watch: {
    event: {
      immediate: true,
      handler(newVal) {
        this.eventData = {...newVal};
        this.initialEventCode = newVal.code;
        this.initialEventName = newVal.name;
      },
    },
    'eventData.code': async function (newCode, oldCode) {
      if (newCode !== oldCode && newCode !== this.initialEventCode) {
        const result = await checkEventCodeUnique(this.organisation.slug, newCode);
        if (result.status === 'unique') {
          this.eventCodeError = '';
        } else {
          this.eventCodeError = 'Event code is not unique for this organisation';
        }
      } else {
        this.eventCodeError = '';
      }
    },
    'eventData.name': async function (newName, oldName) {
      if (newName !== oldName && newName !== this.initialEventName) {
        const result = await checkEventNameUnique(this.organisation.slug, newName);
        if (result.status === 'unique') {
          this.eventNameError = '';
        } else {
          this.eventNameError = 'Event name is not unique for this organisation';
        }
      } else {
        this.eventNameError = '';
      }
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
  },
  methods: {
    async saveEvent() {
      this.$emit('save-event', this.eventData);
    },
    handleEnterKey() {
      if (!this.isSaveButtonDisabled) {
        this.saveEvent();
      }
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>